// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxeth } from "../../../icons/full/build/icon-stataxeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxethIcon.displayName = 'StataxethIcon';
}

export default StataxethIcon;